// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

import { IconUserPlus } from '@tabler/icons-react';

const mescoordonnees = {
    id: 'mes-coordonnees',
    title: <FormattedMessage id="mes-coordonnees" />,
    icon: IconUserPlus,
    type: 'group',
    url: '/ui/mes-coordonnees'
};

export default mescoordonnees;
